import { FC, useCallback } from 'react';

import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import Loader from '../../../../../components/loader/index';
import { Modal } from '../../../../../components/modal/index';
import { useUpdateTemplate } from '../../hooks/use-update-template.hook';
import { TemplatePopupStore } from '../../store/template-popup.store';

export const UpdateTemplatePopup: FC = () => {
  const isOpen = TemplatePopupStore(({ open }) => open);
  const metadata = TemplatePopupStore(({ metadata }) => metadata);
  const updatePayload = TemplatePopupStore(({ updatePayload }) => updatePayload);
  const handleAccept = TemplatePopupStore(({ handleAccept }) => handleAccept);
  const handleDismiss = TemplatePopupStore(({ handleDismiss }) => handleDismiss);

  const { isPending, updateTemplate } = useUpdateTemplate({
    onSuccess: handleAccept,
    templateDocumentName: updatePayload?.documentName ?? '',
    templateFileLink: updatePayload?.fileLink ?? '',
    templateId: metadata ?? '',
  });

  const handleConfirmUpdate = useCallback(() => {
    if (!updatePayload) return;
    updateTemplate(updatePayload.form);
  }, [updatePayload, updateTemplate]);

  return (
    <Modal
      description={<AppFormattedMessage id="UPDATE_TEMPLATE_MESSAGE" />}
      dismissButtonContent={<AppFormattedMessage id="NO" />}
      isOpen={isOpen}
      onDismiss={handleDismiss}
      onSuccess={handleConfirmUpdate}
      successButtonClassName="bg-brand-700"
      successButtonContent={
        isPending ? <Loader iconClassName="size-6" /> : <AppFormattedMessage id="YES_UPDATE" />
      }
      successButtonDisabled={isPending}
      title={<AppFormattedMessage id="UPDATE_TEMPLATE_TITLE" />}
    />
  );
};
